import { render, staticRenderFns } from "./WizardNavigation.vue?vue&type=template&id=1bfc1530&scoped=true&"
import script from "./WizardNavigation.vue?vue&type=script&lang=js&"
export * from "./WizardNavigation.vue?vue&type=script&lang=js&"
import style0 from "./WizardNavigation.vue?vue&type=style&index=0&id=1bfc1530&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfc1530",
  null
  
)

export default component.exports